module.exports = __webpack_public_path__ + "img/fast forward.ecde5dd2.svg";